"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_i18next_1 = require("react-i18next");
const styled_1 = __importDefault(require("@emotion/styled"));
function default_1() {
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(NoticeWrapper, { children: [(0, jsx_runtime_1.jsx)("h2", { children: t('판매를 더 쉽게!') }), (0, jsx_runtime_1.jsx)("h2", { children: `${t('폰디에게 맡겨주세요')}🧡` }), (0, jsx_runtime_1.jsxs)("div", Object.assign({ css: { display: 'flex', justifyContent: 'space-around', marginTop: 30 } }, { children: [(0, jsx_runtime_1.jsxs)(PromiseContainer, { children: [(0, jsx_runtime_1.jsx)("img", { src: `${process.env.CDN_URL}/assets/svgs/notice_setting.svg`, css: { width: '45px', height: '45px', marginBottom: '12px' } }), (0, jsx_runtime_1.jsx)("h4", { children: t('환불') }), (0, jsx_runtime_1.jsx)("h4", { children: t('판매 무산') })] }), (0, jsx_runtime_1.jsxs)(PromiseContainer, { children: [(0, jsx_runtime_1.jsx)("img", { src: `${process.env.CDN_URL}/assets/svgs/notice_bank_book.svg`, css: { width: '45px', height: '45px', marginBottom: '12px' } }), (0, jsx_runtime_1.jsx)("h4", { children: t('자동입금확인') }), (0, jsx_runtime_1.jsx)("h4", Object.assign({ style: { fontSize: 12, color: '#EE7744' } }, { children: t('작가님 계좌노출X') }))] }), (0, jsx_runtime_1.jsxs)(PromiseContainer, { children: [(0, jsx_runtime_1.jsx)("img", { src: `${process.env.CDN_URL}/assets/svgs/notice_bill.svg`, css: { width: '45px', height: '45px', marginBottom: '12px' } }), (0, jsx_runtime_1.jsx)("h4", { children: t('현금영수증 발행') })] })] }))] }));
}
exports.default = default_1;
const NoticeWrapper = styled_1.default.div `
  width: 100%;
  padding: 20px;
  h4 {
    font-size: 17px;
    line-height: 24px;
    text-align: center;
    letter-spacing: -0.2px;
    color: #000000;
  }
  h5 {
    font-size: 16px;
    line-height: 22px;
    text-align: center;
    letter-spacing: -0.2px;
    color: rgba(0, 0, 0, 0.7);
  }
  h2 {
    font-weight: 700;
    font-size: 24px;
    line-height: 38px;
    letter-spacing: -0.2px;
    color: #000;
  }
`;
const PromiseContainer = styled_1.default.div `
  display: flex;
  align-items: center;
  flex-direction: column;
  min-width: 110px;
  width: 30%;
  height: 120px;
  padding-top: 15px;
  background: #ffffff;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  h4 {
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;
    text-align: center;
    letter-spacing: -0.002em;
    color: #000000;
  }
`;
const PromiseContents = styled_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  h4 {
    font-weight: 700;
    font-size: 15px;
    line-height: 22px;
    text-align: center;
    letter-spacing: -0.2px;
    color: #000000;
  }
  span {
    width: 67px;
    height: 24px;
    left: 243px;
    top: 276px;
    background: #ee8844;
    border-radius: 30px;
    font-weight: 700;
    font-size: 13px;
    line-height: 22px;
    text-align: center;
    letter-spacing: -0.2px;
    color: #ffffff;
  }
`;
